import useSWRImmutable from "swr/immutable";

import { HomepageSearchResult } from "@/search/api/types";
import { transformSitewideResults } from "@/search/utils/sitewideResult";
import { getJSONWithCredentials } from "@/utils/swr";

import { SuggestionListResponse } from "./types";

const SUGGESTION_LIST_ERRORS = {
  GENERIC_ERROR: "Unable to load suggestions",
};

const suggestionListUrl = (): string =>
  `${import.meta.env.VITE_API_HOST}/api/suggestions`;

const fetchSuggestionList = getJSONWithCredentials<SuggestionListResponse>(
  SUGGESTION_LIST_ERRORS.GENERIC_ERROR,
);

export const useSuggestionListQuery = () => {
  const { data, error, isLoading } = useSWRImmutable(
    suggestionListUrl(),
    fetchSuggestionList,
  );

  const suggestions = data?.data || [];

  return {
    suggestions: transformSitewideResults(
      suggestions,
    ) as unknown as HomepageSearchResult[],
    isLoading,
    error:
      error ||
      (data?.errors && data.errors.length > 0 ? data.errors[0] : undefined),
  };
};
